










































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { FlixcheckApi } from '@/services/integrations/FlixcheckApi';
import { IDamage, IFlixcheckCheck, IPolicy } from 'admiral-core';
import { PropType } from 'vue';
import {
  ExternalLinkIcon,
  ChevronDownIcon,
  CheckCircleIcon,
  EditIcon,
  DownloadIcon,
} from 'vue-feather-icons';
import { Util } from '@/utils/Util';
import GoToFlixcheckCreateCheckButton from '@/components/integrations/flixcheck/GoToFlixcheckCreateCheckButton.vue';
import ContextMenu from '@/components/common/ContextMenu.vue';

@Component({
  components: {
    ExternalLinkIcon,
    GoToFlixcheckCreateCheckButton,
    ChevronDownIcon,
    CheckCircleIcon,
    ContextMenu,
    EditIcon,
    DownloadIcon,
  },
})
export default class FlixcheckPolicyChecksOverview extends mixins(BaseMixin) {
  @Prop({ required: false, type: Object as PropType<IPolicy> })
  policy?: IPolicy;

  @Prop({ required: false, type: Object as PropType<IDamage> })
  damage?: IDamage;

  loading = false;

  checks: IFlixcheckCheck[] = [];

  @Watch('policy')
  onPolicyChange() {
    if (!this.policy) {
      return;
    }
    this.checks = this.policy.integrationFlixcheckChecks;
  }

  @Watch('damage')
  onDamageChange() {
    if (!this.damage) {
      return;
    }
    this.checks = this.damage.integrationFlixcheckChecks;
  }

  get newFlixcheckChecks() {
    return this.$store.getters['socketConnection/getFlixcheckChecks'] || [];
  }

  @Watch('newFlixcheckChecks')
  onNewFlixcheckChecksChange() {
    for (const check of this.newFlixcheckChecks) {
      if (
        this.policy &&
        !this.checks.find((c) => c.checkId === check.checkId) &&
        this.policy.id === check.policy.id
      ) {
        this.checks.push(check);
        this.loading = false;
      }
      if (
        this.damage &&
        !this.checks.find((c) => c.checkId === check.checkId) &&
        this.damage.id === check.damage.id
      ) {
        this.checks.push(check);
        this.loading = false;
      }
    }
    this.$emit('checks-changed', this.checks);
  }

  externalOpenUrl(check: IFlixcheckCheck) {
    if (check.answeredAt) {
      return `https://app.flixcheck.com/portal/checks/inbox/${check.checkId}`;
    }
    return `https://app.flixcheck.com/portal/checks/sent/${check.checkId}`;
  }

  externalEditUrl(check: IFlixcheckCheck) {
    return `https://app.flixcheck.com/portal/edit/check/${check.checkId}`;
  }

  async downloadDocuments(check: IFlixcheckCheck) {
    try {
      this.loading = true;
      await FlixcheckApi.downloadDocuments(check.checkId);
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  formatDate(date: Date) {
    return Util.formatDate(date);
  }

  async goToFlixcheckCreateCheck() {
    this.loading = true;
    try {
      if (this.policy) {
        const response = await FlixcheckApi.createPrefilledPolicyUrl({
          policyId: this.policy.id,
        });
        window.open(response.data.resource.redirectUrl, '_blank');
      } else if (this.damage) {
        const response = await FlixcheckApi.createPrefilledDamageUrl({
          damageId: this.damage.id,
        });
        window.open(response.data.resource.redirectUrl, '_blank');
      }
    } catch (error) {
      console.error(error);
    }
  }
}
